/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  return typeof str === 'string' && str.trim().length > 0
}

// 支持国际号码：+区号+号码，去掉+后验证（美国+1后为10位，其他地区至少3位数字）
export function validatePhone(value) {
  if (!value) return false
  // 去掉所有空白符
  value = value.trim()
  // 如果带+号认为是国际号码，简单验证格式
  if (value.startsWith('+')) {
    const rest = value.substring(1)
    // 国际号码：+区号(1-4位)+号码(4-15位)
    return /^\d{1,4}\d{4,15}$/.test(rest)
  }
  // 国内号码
  const reg = /^[1][3-9][0-9]{9}$/
  return reg.test(value)
}

export function validateCode(value) {
  const reg = /^[1][3-9][0-9]{9}$/

  if (!/^(?![0-9]*$)(?![a-zA-Z]*$)[a-zA-Z0-9]{6}$/.test(value)) {
    return false
  } else {
    return true
  }
}
